(function() {
    'use strict';
    angular
        .module('consulatApp')
        .factory('Consulat', Consulat)
        .factory('ConsulatTop1', ConsulatTop1);

    Consulat.$inject = ['$resource'];
    ConsulatTop1.$inject = ['$resource'];

    function Consulat ($resource) {
        var resourceUrl =  'api/consulats/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }

    function ConsulatTop1 ($resource) {
        var resourceUrl =  'api/consulats/consulatTop1';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }

})();
